import * as React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { PATH_APP } from "./paths";
import ProtectedRouter from "./ProtectedRouter";
// import Footer from "../views/Layout/Footer";
import UnProtectedRouter from "./UnProtectedRouter";
import Footer from "@/views/Layout/Footer";
import Price from "@/views/Price";
import { JwtProvider } from "@/components/Auth/JwtProvider";
import DeleteAccount from "@/views/DeleteAccount";
import ScrollTop from "@/components/ScrollTop";

function renderRoutes() {
	return (
		<BrowserRouter>
			<ScrollTop />
			<React.Suspense
				fallback={
					<div
						style={{
							backgroundColor: "black",
							height: "100vh",
							width: "100vh",
							zIndex: 9999,
						}}
					>
						로딩중..
					</div>
				}
			>
				<Switch>
					<Route
						exact={true}
						path={PATH_APP.price.root}
						render={() => (
							<JwtProvider>
								<Price />
							</JwtProvider>
						)}
					/>
					<Route
						exact={true}
						path={PATH_APP.account.delete}
						render={() => (
							<JwtProvider>
								<DeleteAccount />
							</JwtProvider>
						)}
					/>
					<Route path={PATH_APP.auth.root} component={UnProtectedRouter} />
					<Route path={PATH_APP.root} component={ProtectedRouter} />
				</Switch>
				<Footer />
			</React.Suspense>
		</BrowserRouter>
	);
}

export { renderRoutes };
